import { ContentfulCarousel, ContentfulProductBlock } from '@jbhi-fi/apis/src/contentful/types';
import { ThemeTransformer } from './ThemeTransformer';
import React from 'react';
import { TabsBlockProps } from '../../TabsBlock/TabsBlock';
import { ListingBlockHeading } from '../../ListingBlock/ListingBlockHeading';
import { CarouselTransformer, ToProductCarouselBaseOptions } from './CarouselTransformer';
import { ContentBlockProps } from '../../ContentBlock';
import { CarouselLeadImage } from '../../CarouselLeadImage/CarouselLeadImage';
import { ContentEntry } from '../../ContentEntry/contentEntries';

export abstract class ProductBlockTransformer {
  static toContentBlockProps = (entry?: ContentfulProductBlock): Partial<ContentBlockProps> => {
    const theme = ThemeTransformer.toContentThemeVariables(entry?.fields?.theme);

    return {
      style: { backgroundColor: theme?.palette?.background },
    };
  };

  static toTabsBlockProps = (
    entry?: ContentfulProductBlock,
    options: ToProductCarouselBaseOptions = {}
  ): TabsBlockProps => {
    return {
      testId: options?.testId,
      heading: <ListingBlockHeading heading={entry?.fields?.heading} />,
      palette: ThemeTransformer.toContentThemePalette(entry?.fields?.theme),
      tabs:
        (entry?.fields?.productCarousel
          ?.filter(carousel => carousel?.fields)
          ?.map(carousel => {
            const { Component, transformer } = this._toTabsBlockContentEntryProps(carousel, options);
            const props = transformer?.(carousel);
            if (!transformer || !Component || !props) {
              return null;
            }
            return {
              label: carousel?.fields?.heading ?? '',
              contents: <Component {...props} {...(carousel.fields?.type === 'Product' ? { heading: '' } : {})} />,
            };
          })
          .filter(Boolean) as TabsBlockProps['tabs']) ?? [],
    };
  };

  static _toTabsBlockContentEntryProps = (
    entry: ContentfulCarousel,
    options: ToProductCarouselBaseOptions = {}
  ): ContentEntry => {
    // We want to force the buttonType to be 'Link' when a carousel is in a ProductBlock
    if (entry.fields?.buttonType && entry.fields.buttonType !== 'None') entry.fields.buttonType = 'Link';
    switch (entry.fields?.type) {
      case 'Product with Lead Image':
        return {
          Component: CarouselLeadImage,
          transformer: e =>
            CarouselTransformer.toCarouselLeadImageProps(e, {
              shouldHideHeadingOnMobile: true,
              ...options,
            }),
        };
      default:
        return CarouselTransformer.toContentEntryProps(entry, { ...options });
    }
  };
}
